/**
 * @prop --background: Background color of calendar
 * @prop --padding-top: Padding top of calendar
 * @prop --padding-bottom: Padding bottom color of calendar
 * @prop --padding-left: Padding left color of calendar
 * @prop --padding-right: Padding right color of calendar
 * @prop --background-color: Background color of calendar
 */

:host {
  --padding-top: #{space('small')};
  --padding-bottom: #{space('small')};
  --padding-left: #{space('xsmall')};
  --padding-right: #{space('xsmall')};

  width: #{$calendarWidth};
}

.stzh-calendar {
  --stzh-description-min-height: initial;

  display: flex;
  position: relative;
  text-align: left;
  touch-action: pan-y;
  user-select: none;
  overflow: hidden;
  overflow: clip;
  padding-top: var(--padding-top);
  padding-bottom: var(--padding-bottom);
  padding-left: var(--padding-left);
  padding-right: var(--padding-right);

  &__wrapper {
    width: 100%;
  }

  &__table {
    @include font;
    @include fontSize('milli');
    border-collapse: collapse;
    border-spacing: 0;
    text-align: center;
    width: 100%;
  }

  &__table-header,
  &__cell {
    padding: space('xxxsmall');

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }

  &__row:last-child &__cell {
    padding-bottom: 0;
  }

  &__table-header {
    @include font;
    @include fontSize('nano');
    text-decoration-line: none;
    padding-top: 0;
    padding-bottom: 0;
    width: 44px;
    height: 40px;
  }

  &__cell {
    text-align: center;
  }

  &__day {
    @include font;
    @include fontSize('milli');
    appearance: none;
    background: transparent;
    border: 0;
    cursor: pointer;
    display: inline-block;
    font-variant-numeric: tabular-nums;
    width: 40px;
    height: 40px;
    text-align: center;
    vertical-align: middle;
    transition-property: color, background-color;
    transition-duration: $baseTransitionAnimationSpeed;
    // position: relative;
    // padding: 0 0 1px;
    // z-index: 1;

    // &::before {
    //   z-index: -1;
    //   bottom: 0;
    //   content: "";
    //   left: 0;
    //   position: absolute;
    //   right: 0;
    //   top: 0;
    // }

    &.is-today {
      @include font('heavy');
      color: $colorPrimary70;
      // box-shadow: 0 0 0 1px $colorPrimary;
      // position: relative;
      // z-index: 200;
    }

    &:hover {
      background: $colorGrey20;
    }

    // &:hover::before {
    //   background: $colorGrey20;
    // }

    // &:focus,
    &[aria-pressed="true"] {
      background: $colorSecondary30;
      // box-shadow: none;
      color: $colorPrimary70;
    }

    &:active {
      background: $colorSecondary30;
      // box-shadow: 0 0 5px $colorPrimary;
      color: $colorPrimary70;
      // z-index: 200;
    }

    // &:focus {
    //   z-index: 200;
    // }

    // &:not(.is-month) {
    //   box-shadow: none;
    // }

    &:not(.is-month),
    &[aria-disabled="true"] {
      background: transparent;
      color: $colorGrey60;
      cursor: default;
    }

    // &[aria-disabled="true"] {
      // &.is-today {
      //   box-shadow: 0 0 0 1px $colorGrey20;

      //   &:focus {
      //     box-shadow: 0 0 5px $colorPrimary;
      //   }
      // }

      // &::before {
      //   display: none;
      // }
    // }

    &.is-disabled {
      text-decoration-line: line-through;
    }

    &.is-outside {
      color: $colorGrey60;
      background: $colorGrey20;
      // box-shadow: none;
      cursor: default;
      pointer-events: none;
      text-decoration-line: none;

      // &::before {
      //   display: none;
      // }
    }
  }

  &__header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  &__nav {
    display: flex;
    align-items: center;

    &.is-dropdowns {
      gap: calc(#{space('xsmall')} + #{space('small')});
      margin-left: space('small');
    }
  }

  // &__prev,
  // &__next {
  //   align-items: center;
  //   appearance: none;
  //   font-family: inherit;
  //   background: transparent;
  //   border-radius: 50%;
  //   color: $colorPrimary70;
  //   cursor: pointer;
  //   display: inline-flex;
  //   flex-shrink: 0;
  //   justify-content: center;
  //   margin-left: space('xsmall');
  //   padding: 0;
  //   transition: background-color 300ms ease;
  //   height: 32px;
  //   width: 32px;

  //   &:disabled {
  //     cursor: default;
  //     color: $colorGrey60;
  //   }
  // }

  stzh-dropdown#{&}__dropdown {
    --popover-width: 100%;
    --popover-height: calc(100% - #{$formInputHeightSmall} - var(--padding-top));
    --popover-max-height: initial;
    position: static;
  }

  &__select-wrapper {
    display: inline-flex;
    position: relative;

    span {
      margin-right: 0px;
    }
  }

  &__select {
    @include fontSize('milli');
    cursor: pointer;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 2;
    border-radius: $formInputBorderRadius;
  }

  &__select-label {
    @include fontSize('milli');
    appearance: none;
    border: none;
    align-items: center;
    border-radius: $formInputBorderRadius;
    color: $colorPrimary70;
    display: flex;
    gap: space('xsmall');
    padding: 0;
    padding-left: space('small');
    padding-right: space('xsmall');

    position: relative;
    width: 100%;
    min-height: 40px;
    z-index: 1;
  }

  &__select-icon {
    --size: #{iconSize('xsmall')};
  }

  &__vhidden {
    @include visuallyhidden;
  }
}
